import _ from 'lodash';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

export function WidgetTruncatedText ({ text, options = {}, color = '' }) {
    return (
        <Tooltip title={text}>
            <span style={{ color }}>
                {_.truncate(text, _.defaultsDeep({}, options, _.defaultTruncateOptions))}
            </span>
        </Tooltip>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetTruncatedText.displayName = 'WidgetTruncatedText';
}
